import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../../shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../../../shared/helpers/src/react/reactHelpers';
import {Icon} from '../../../../../../../shared/ui/src/components/icon/icon';
import {UserThemeConsumer} from '../../../../../../../shared/ui/src/theme/userThemeConsumer';
import {PageTab} from '../../common/pageTab';

/*
 * Props.
 */

export interface CrmSyncsPageTabsProps {
  isOnErrorsPage: boolean;
  onViewErrorsClick: Handler;
  onSyncSettingsClick: Handler;
}

/*
 * Style.
 */

const StyledErrorTitleDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

/*
 * Component.
 */

export const CrmSyncsPageTabs: FC<CrmSyncsPageTabsProps> = (props) => {
  const {isOnErrorsPage, onViewErrorsClick, onSyncSettingsClick} = props;
  return (
    <>
      <PageTab
        title={<Trans id="crm-syncs-page-sync-settings-tab-title">Sync settings</Trans>}
        isSelected={!isOnErrorsPage}
        onClick={() => onSyncSettingsClick()}
      />
      <PageTab
        title={
          <UserThemeConsumer>
            {(theme) => (
              <StyledErrorTitleDiv>
                <Icon color={theme.palette.orange.shade40} name="warningFilledSmall" />
                <Trans id="crm-syncs-page-errors-tab-title">Errors</Trans>
              </StyledErrorTitleDiv>
            )}
          </UserThemeConsumer>
        }
        isSelected={isOnErrorsPage}
        onClick={() => onViewErrorsClick()}
      />
    </>
  );
};
